import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RequiredIndicatorComponent } from './required-indicator.component';

@NgModule({
  declarations: [RequiredIndicatorComponent],
  imports: [CommonModule],
  exports: [RequiredIndicatorComponent],
})
export class RequiredIndicatorModule {}
